// Maybe — sum of Just<A> and Nothing. Tagged shape with prefixed
// tags.
//
// Consumer API: `Maybe.just(x)`, `Maybe.nothing`, `Maybe.isSome(m)`,
// `Maybe.isNone(m)`, `Maybe.map(f)(m)`, `Maybe.flatMap(f)(m)`,
// `Maybe.getOrElse(default)(m)`, `Maybe.fromNullable(x)`,
// `Maybe.match({just, nothing})(m)`.
export { flatMap, fromNullable, getOrElse, isNone, isSome, just, map, match, nothing, };
const just = (value) => ({ _tag: "Maybe.Just", value });
const nothing = { _tag: "Maybe.Nothing" };
const isSome = (m) => m._tag === "Maybe.Just";
const isNone = (m) => m._tag === "Maybe.Nothing";
const map = (f) => (m) => isSome(m) ? just(f(m.value)) : m;
const flatMap = (f) => (m) => isSome(m) ? f(m.value) : m;
const getOrElse = (fallback) => (m) => isSome(m) ? m.value : fallback;
const fromNullable = (a) => a === null || a === undefined ? nothing : just(a);
const match = (cases) => (m) => isSome(m) ? cases.just(m.value) : cases.nothing();
//# sourceMappingURL=maybe.js.map